import { Component, OnInit, ViewChild, OnDestroy, ElementRef, AfterViewInit, ChangeDetectorRef, HostListener, Inject } from "@angular/core";
// import { ROUTES } from './vertical-menu-routes.config';
// import { HROUTES } from '../horizontal-menu/navigation-routes.config';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { AlertServices, AppServices, UserServices } from '@services';
import { MenuStructure } from '@interfaces';
import { environment as env } from 'environments/environment';
import { decodedTextSpanIntersectsWith } from "typescript";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;

  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  logoUrl: string = null;
  AppTitle: string = null;
  _ServerURL = env.app_apiURL;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    @Inject('UserServices') private _userServices: UserServices,
    @Inject('AppServices') private _appServices: AppServices,
    @Inject('AlertServices') private _alertServices: AlertServices,
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    // this.menuItems = ROUTES;


    //Based on User Instance get the Logo Url and Instance Name to change Tile
    let LoggedInUser = this._userServices.getLoggedInUser()

    this._userServices.GetUserInstanceDetails(LoggedInUser.InstanceID).subscribe(data => {
      if (data.length > 0) {
        this.AppTitle = data[0].Title
       // data[0].Logo ? this.logoUrl = this._ServerURL + data[0].Logo : this.logoUrl = 'assets/img/logo.png';
        data[0].Logo ? this.logoUrl = this._ServerURL + data[0].Logo : null;
      }


    }, (_error) => {

    });



    //  console.log(this._userServices.getLoggedInUser())

    //CSP.NOTES  Get User Defined Menu
    this._userServices.GetUserMenu().subscribe(data => {
      let LoadUserMenu: MenuStructure[] = JSON.parse(data)
      this.menuItems = LoadUserMenu;
      this.cdr.detectChanges();
      this.cdr.markForCheck()
    }, (_error) => {
      const _ErrorResponse = JSON.parse(_error._body)
      this._alertServices.ShowMessage('error', 'app.trn-error-title', _ErrorResponse.ErrorMessage);
      this._appServices.Logout();
    });





  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200

        //CSP.TODO  Define HROUTES AND LOAD THEM FROM API
        //this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{

      //CSP.TODO  Define ROUTES AND LOAD THEM FROM API
      //this.menuItems = ROUTES;
    }




    // if (this.config.layout.sidebar.backgroundColor === 'white') {
    //   this.logoUrl = 'assets/img/logo-dark.png';
    // }
    // else {
    //   this.logoUrl = 'assets/img/logo.png';
    // }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
